import ConflictComponent from '../components/ConflictComponent';
import EventComponent from '../components/EventComponent';
import { PlannerEcsSystem } from './System';
export class ConflictSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'ConflictSystem', EventComponent.id);
    }
    onAdd() { }
    /**
     * Add ConflictComponent to entites that are in conflict
     */
    onUpdate(entity, oldComponent, newComponent) {
        if (newComponent.event === 'conflict') {
            const conflicts = newComponent.params;
            conflicts.forEach(conflict => {
                const entity = this.coreApi.entities.find(conflict.entityId);
                if (entity) {
                    entity.addComponent(new ConflictComponent());
                }
            });
        }
    }
    onRemove() { }
}
//# sourceMappingURL=ConflictSystem.js.map